// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-container[data-v-b8045d18],\n.c-loading-screen[data-v-b8045d18] {\n  height: calc(var(--c-content-viewport-height));\n  width: 100%;\n}\n.c-container[data-v-b8045d18] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.c-canvas[data-v-b8045d18] {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
